<template>
    <div class="vueCalc">
      
        <!-- <v-switch :true-value="true" :false-value="false" v-model='calcs.thrombophiliaAlgorithm' label="thrombophiliaAlgorithm"></v-switch> -->
        <thrombophiliaAlgorithm :language="language" v-if="calcs.thrombophiliaAlgorithm"/>
        <!-- <v-switch :true-value="true" :false-value="false" v-model='calcs.vipitAlgorithm' label="vipitAlgorithm"></v-switch> -->
        <vipitAlgorithm :language="language" v-if="calcs.vipitAlgorithm"/>
        <vteManagement :language="language" v-if="calcs.vteManagement"/>
        <atrialFibrillationManagement :language="language" v-if="calcs.atrialFibrillationManagement"/>
        <khoranaCalculator :language="language" v-if="calcs.khoranaCalculator"/>
        <PeClassification :language="language" v-if="calcs.PeClassification" :options="{autoLaunch: true, showLanguageToggle: false}"/>
        <BleedManagement :language="language" v-if="calcs.BleedManagement" :options="{showLanguageToggle: false}"/>
        <DvtManagement :language="language" v-if="calcs.DvtManagement" :options="{showLanguageToggle: false}"/>
        <PeManagement :language="language" v-if="calcs.PeManagement" :options="{showLanguageToggle: false}"/>
        <DoacFollowup :language="language" v-if="calcs.DoacFollowup" :options="{showLanguageToggle: false}"/>
        
  </div>
</template>

<script>
import vipitAlgorithm from './vueCalculators/vipitAlgorithm'
import thrombophiliaAlgorithm from './vueCalculators/thrombophiliaAlgorithm'
import vteManagement from '../PatientSupportTools/tools/vteManagement.vue'
import atrialFibrillationManagement from './vueCalculators/atrialFibrillationManagement.vue'
import khoranaCalculator from './vueCalculators/khoranaCalculator.vue'
import PeClassification from './vueCalculators/peClassification.vue'
import BleedManagement from './vueCalculators/bleedManagement.vue'
import DvtManagement from './vueCalculators/dvtManagement.vue'
import PeManagement from './vueCalculators/peManagement.vue'
import DoacFollowup from './vueCalculators/doacFollowup.vue'

export default {
    props: {
        language: {
            type: String,
            required: true
        }
    },
    components: {
        vipitAlgorithm,
        thrombophiliaAlgorithm,
        vteManagement,
        atrialFibrillationManagement,
        khoranaCalculator,
        PeClassification,
        BleedManagement,
        DvtManagement,
        PeManagement,
        DoacFollowup
    },
    data: function(){
        return {
            calcs: {
                vipitAlgorithm: true,
                thrombophiliaAlgorithm: true,
                atrialFibrillationManagement: true,
                vteManagement: false,
                khoranaCalculator: true,
                PeClassification: true,
                BleedManagement: true,
                DvtManagement: true,
                PeManagement: true,
                DoacFollowup: true
            }
        }
    }
}
</script>

<style lang="scss">
.vueCalc .v-label{
    margin: 10px 0px 10px 0px !important;
}
</style>